import * as React from "react";
import { View, StyleSheet, TextInput, Button, ScrollView } from "react-native";
import { MonoText } from "../components/StyledText";
import { useWindowDimensions } from "react-native";
import { backendUrl } from "../constants/Environment";
import { AppDataContext } from "../context/AppDataProvider.js";
import NavbarMobileScreen from "./NavbarMobileScreen";
import NavbarDesktop from "../components/NavbarDesktop";

export default function SubscribeNewsletter({ navigation }) {
  function header() {
    return (
      <View
        style={{
          borderStyle: "dotted",
          borderTopWidth: 0,
          borderBottomWidth: 2,
          flex: 2,
          margin: 16,
          marginBottom: 0,
          color: colors.text,
          borderBottomColor: colors.text,
        }}
      >
        <MonoText
          style={{
            fontSize: 32,
            fontWeight: "bold",
            color: colors.text,
          }}
        >
          Subscribe
        </MonoText>
      </View>
    );
  }

  const styles = StyleSheet.create({
    input: {
      height: 40,
      margin: 12,
      borderWidth: 1,
      padding: 10,
    },
  });

  const [inputFirstName, setInputFirstName] = React.useState("");
  const [inputLastName, setInputLastName] = React.useState("");
  const [inputEmail, setInputEmail] = React.useState("");
  const [formSubmitted, setFormSubmitted] = React.useState(false);

  const { colors } = React.useContext(AppDataContext);

  /**
   * YOU NEED TO ADD YOUR MAILCHIMP API KEY AND URLS.
   *
   * Change usX.api. to your datacentre.
   * Change <YOUR_AUDIENCE_ID> to your list id
   * Change <YOUR_API_KEY> to your api key
   * Keep FNAME and LNAME or delete them in the MailChimp setup.
   */
  function sendData() {
    const data = {
      firstName: inputFirstName,
      lastName: inputLastName,
      email: inputEmail,
    };
    const postData = JSON.stringify(data);
    fetch(`${backendUrl}/newsletter-signup`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: postData,
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));
  }

  function form() {
    return (
      <ScrollView style={{ flex: 14, margin: 24, marginTop: 8 }}>
        <br></br>
        <MonoText
          style={{ fontSize: 18, fontWeight: "bold", color: colors.text }}
        >
          Sign up to the Designo Newsletter
        </MonoText>
        <br></br>
        <br></br>
        <MonoText style={{ fontSize: 16, color: colors.text }}>
          Designo News is the leading authority on the latest news and the
          definitive home for trending technology and news. To make sure you are
          up to date with the latest from the world of technology, sign up to
          the Designo News newsletter. We'll send you the best comment, analysis
          and opinion from our tech industry experts, and our reviews of the
          world's best tech, direct to your email inbox.
        </MonoText>
        <br></br>
        <MonoText style={{ fontSize: 16, color: colors.text }}>
          Fill in the boxes below and we'll do the rest.
        </MonoText>
        {!formSubmitted && (
          <React.Fragment>
            <TextInput
              style={styles.input}
              onChangeText={setInputEmail}
              value={inputEmail}
              placeholder="Email"
              keyboardType="email-address"
            />
            <TextInput
              style={styles.input}
              onChangeText={setInputFirstName}
              value={inputFirstName}
              placeholder="First Name"
            />
            <TextInput
              style={styles.input}
              onChangeText={setInputLastName}
              value={inputLastName}
              placeholder="Last Name"
            />
            <Button
              style={{
                height: 40,
                margin: 12,
                borderWidth: 1,
                paddingTop: 24,
                padding: 10,
              }}
              onPress={() => {
                sendData();
              }}
              title="Submit"
            >
              {"Submit"}
            </Button>
          </React.Fragment>
        )}
        {formSubmitted && (
          <React.Fragment>
            <MonoText
              style={{
                fontSize: 16,
                borderStyle: "dotted",
                borderTopWidth: 2,
                borderBottomWidth: 0,
                flex: 2,
                color: colors.text,
              }}
            >
              You have successfully been subscribed to the newsletter.
            </MonoText>
          </React.Fragment>
        )}
        <View
          style={{
            flex: 2,
            margin: 16,
          }}
        >
          <MonoText
            style={{
              fontSize: 16,
              flex: 2,
              color: colors.text,
            }}
          >
            Designo News takes your privacy seriously. You can unsubscribe at
            any time using the unsubscribe function on any email you receive
            from us. We will use your information to ensure you receive messages
            that are relevant to you. To learn more about how we use the
            information you provide to us please see our website
            www.designonewsexample.com/privacy
          </MonoText>
        </View>
      </ScrollView>
    );
  }

  const { width } = useWindowDimensions();

  return (
    <View style={{ flex: 1, flexDirection: "column" }}>
      <View pointerEvents="box-none" style={{ elevation: 2, zIndex: 2, }}>
        <NavbarDesktop
          navigate={navigation.navigate}
          setParams={navigation.setParams}
        ></NavbarDesktop>
      </View>
      <View
        style={
          width > 1000
            ? {
              justifyContent: "center",
              marginLeft: "auto",
              marginRight: "auto",
              width: 974,
            }
            : {}
        }
      >
        {header()}
        {form()}
      </View>
    </View>
  );
}
